<div style="margin-top: 20px; margin-bottom: 10px; display: inline-flex">
  <div class="container">
    <div class="button-wrap">
      <!-- ✅ Add (click)="onSelectFileClick($event)" -->
      <label class="button" for="fileUpload" (click)="onSelectFileClick($event)">
        {{ "app.importOrders.selectFile" | translate }}
      </label>

      <input id="fileUpload" type="file" (change)="selectFile($event)" accept=".xlsx" style="display: none" />
    </div>
  </div>

  <button
    style="white-space: nowrap; min-width: 160px"
    mat-flat-button
    color="primary"
    [disabled]="!fileName"
    (click)="upload()"
  >
    {{ "app.importOrders.upload" | translate }}
    <mat-icon class="material-icons">upload</mat-icon>
  </button>

  <div id="uploadToastTarget"></div>
</div>

<span id="fileName" class="with-icon">
  @if (fileName) {
    <mat-icon>cloud_upload</mat-icon>
  }
  &nbsp;&nbsp;{{ fileName }}
</span>

@if (uploadProgress) {
  <div>
    <div>{{ uploadProgress }}%</div>
    <mat-progress-bar [value]="uploadProgress"></mat-progress-bar>
  </div>
}

@if (isProcessing) {
  <app-processing-overlay [message]="'app.misc.processing' | translate"> </app-processing-overlay>
}
